import React from "react";
import { XIcon } from "@heroicons/react/solid";

import Modal from "./Modal";

interface PrimaryModalProps {
  children: React.ReactNode;
  onClose: () => void;
}

// primary modal is a modal with a backdrop and a close button and special styling
const PrimaryModal: React.FC<PrimaryModalProps> = ({ children, onClose }) => {
  return (
    <Modal onClose={onClose}>
      <div className="primary-modal">
        {/* modal container */}
        <div className="container primary-py">
          {/* modal close icon */}
          <div className="flex items-center justify-end md:hidden">
            <XIcon onClick={onClose} className="primary-icon" role="button" />
          </div>
          {/* modal content */}
          <div className="my-6 md:my-0">{children}</div>
        </div>
      </div>
    </Modal>
  );
};

export default PrimaryModal;
